import { AccordionDetails, AccordionSummary, Accordion as MuiAccordion, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Iconify from '../Iconify';

const Accordion = ({ title, children, defaultExpanded, sx, expanded, clear }) => {
  const [isOpen, setIsOpen] = useState(expanded);

  useEffect(() => {
    setIsOpen(expanded);
  }, [expanded]);

  return (
    <MuiAccordion
      expanded={isOpen}
      defaultExpanded={defaultExpanded}
      sx={{
        mt: 4,
        border: (theme) => (theme.palette.mode === 'light' ? '1px solid #dce0e3' : '1px solid #45505c'),
        borderRadius: '10px',
        p: 1,
        width: '100%',
        ...sx,
      }}
    >
      <AccordionSummary
        id="panel1-header"
        aria-controls="panel1-content"
        expandIcon={<Iconify icon={'eva:arrow-ios-downward-fill'} width={22} height={22} />}
        onClick={() => {
          setIsOpen(!isOpen);
          if (clear) clear();
        }}
      >
        <Typography sx={{ color: (theme) => (theme.palette.mode === 'light' ? 'text.secondary' : 'common.white') }}>{title}</Typography>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </MuiAccordion>
  );
};

export default Accordion;
